import React, { Component } from 'react';
import axios from 'axios';
import { Heading } from '../heading/heading';
import { Tooltip, Toast, Label } from '../../UiKit';
import {
  InfoLine,
  Plus,
  CheckCircleFill,
  CrossCircleFill,
} from 'sushiweb/Icons';
import { grey, green, black } from 'sushiweb/tokens/color';
import PhotoViewer from 'sushiweb/PhotoViewer';
import SpinnerCircular from 'sushiweb/Spinner/SpinnerCircular';

import './uploadImage.scss';
export default class UploadImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedImages: [],
      availablePhotos: [],
      riderPhotos: null,
      samplePhotos: null,
      isOpen: false,
      isRiderOpen: false,
      isSampleOpen: false,
      selectedImageInd: 0,
      selectRiderImageIdx: 0,
      selectSampleImageIdx: 0,
      showToast: false,
      toastText: '',
      toastType: 'success',
      isLoading: false,
      uploadImageErrorText:
        'Selecting/Adding photos is mandatory for issuing this refund.',
    };
    this.height = 0;
    this.timerId = null;
  }

  componentDidMount() {
    this.getAvailablePhotos();
    this.timerId = setTimeout(() => {
      this.setMarginTopForMainComp();
    }, 500);
  }

  setMarginTopForMainComp = () => {
    const headerNode = document.querySelector('.fixedHeaderSmartplug');
    const mainNode = document.getElementById('main');
    if (!headerNode || !mainNode) return null;
    this.height = headerNode.clientHeight;
  };

  closePhotoViewer = () => {
    this.setState({
      isOpen: false,
      isRiderOpen: false,
      isSampleOpen: false,
    });
  };

  addPhoto = (index, imageType) => {
    const photoViewerNode = document.getElementById('photoViewer');
    this.setState(() => {
      if (imageType === 'rider')
        return {
          isRiderOpen: true,
          selectRiderImageIdx: index,
        };
      else if (imageType === 'sample')
        return {
          isSampleOpen: true,
          selectSampleImageIdx: index,
        };

      return {
        isOpen: true,
        selectedImageInd: index,
      };
    });
    photoViewerNode.firstChild.style.marginTop = `${this.height}px `;
  };

  getAvailablePhotos = () => {
    const { imageUploader } = this.props;
    if (!imageUploader) return;
    let riderPhotoArray = imageUploader.rider_uploaded_images;
    let samplePhotoArray = imageUploader.sample_images;

    if (riderPhotoArray) {
      for (let i = 0; i < riderPhotoArray.length; i++) {
        riderPhotoArray[i].src = riderPhotoArray[i].url;
      }
    }

    if (samplePhotoArray) {
      for (let i = 0; i < samplePhotoArray.length; i++) {
        samplePhotoArray[i].src = samplePhotoArray[i].url;
      }
    }

    this.setState({
      availablePhotos: imageUploader.uploaded_images,
      riderPhotos: riderPhotoArray,
      samplePhotos: samplePhotoArray,
    });
  };

  uploadAvailablePhotos = (selectedImage) => {
    const { fileUpload } = this.props;
    const { availablePhotos, uploadedImages } = this.state;
    let remainingImages =
      availablePhotos &&
      availablePhotos.filter((item) => {
        return item.url !== selectedImage.url;
      });
    selectedImage['src'] = selectedImage.url;
    this.setState({
      availablePhotos: remainingImages,
      uploadedImages: [...uploadedImages, ...[selectedImage]],
    });
    return fileUpload([...uploadedImages, ...[selectedImage]]);
  };

  onChange = (event) => {
    const { fileUpload, orderId, reasonId, url } = this.props;
    const { uploadedImages } = this.state;
    if (!url) return;
    const files = event.target.files;
    let imagesArr = [];
    let images = {};
    const finalUrl = `${window.dashboard.domain}/lifeline_apis/issues/raise_issue/${reasonId}/${url}`;
    const formData = new FormData();

    this.setState({
      isLoading: true,
    });

    for (let i = 0; i < files.length; i++) {
      imagesArr =
        uploadedImages &&
        uploadedImages.filter((item) => {
          return item.name === files[i].name;
        });
      images['src'] = files[i];
      formData.append(`files[]`, files[i]);
    }

    if (imagesArr && imagesArr.length) {
      this.setState({ isLoading: false });
      return;
    }

    formData.append('order_id', orderId);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };

    return axios
      .post(finalUrl, formData, config)
      .then((res) => {
        if (!res || (res && res.isError)) return;
        if (
          res &&
          res.data &&
          res.data.length &&
          (res.data[0].error || !res.data[0].valid)
        ) {
          this.setState({
            showToast: true,
            toastType: 'error',
            toastText:
              res.error || 'Something went wrong. Please try again later!',
            isLoading: false,
          });
          return;
        }
        res.data[0]['src'] = res.data[0].url;
        res.data[0]['upload'] = true;
        this.setState({
          uploadedImages: [...uploadedImages, ...res.data],
          isLoading: false,
        });
        return fileUpload([...uploadedImages, ...res.data]);
      })
      .catch(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  checkIfImageUploded = (index) => {
    const { uploadedImages } = this.state;
    uploadedImages[index]['isUpload'] = true;
    this.setState({
      uploadedImages,
    });
  };

  cancelUploadedImg = (selectedImg) => {
    const { fileUpload } = this.props;
    const { availablePhotos, uploadedImages } = this.state;
    let remainingUploadedImages =
      uploadedImages &&
      uploadedImages.filter((item) => {
        return item.url !== selectedImg.url;
      });

    this.setState({
      availablePhotos: selectedImg.pre_upload
        ? [...availablePhotos, ...[selectedImg]]
        : [...availablePhotos],
      uploadedImages: remainingUploadedImages,
    });
    return fileUpload(remainingUploadedImages);
  };

  closeToast = () => {
    this.setState({
      showToast: false,
    });
  };

  scrollTo = (ref) => {
    if (ref) {
      ref.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  render() {
    const { imageUploader, uploadImageError } = this.props;
    const {
      uploadedImages,
      availablePhotos,
      riderPhotos,
      samplePhotos,
      selectedImageInd,
      selectRiderImageIdx,
      selectSampleImageIdx,
      isOpen,
      isRiderOpen,
      isSampleOpen,
      showToast,
      toastText,
      toastType,
      isLoading,
      uploadImageErrorText,
    } = this.state;
    return (
      <div className='pt10 pb20 col uploadImageContainer'>
        <div className='col'>
          <div className='row'>
            <Heading
              title={`${(imageUploader && imageUploader.text) || 'Add photos'}`}
            />
            <Tooltip
              position='right'
              title={
                <span className='icon iconMarginL'>
                  <InfoLine size={14} color={grey.z500} />
                </span>
              }
              widthMaxContent={false}
              labelWidth={18}
              border={false}
              label='For merchant recovery, please make sure you have added/uploaded relevant photos here.'
            />
          </div>
          {uploadImageError ? (
            <p ref={this.scrollTo} className='red'>
              {uploadImageErrorText}
            </p>
          ) : null}
          <div className='imagesWrapper mt10'>
            {uploadedImages &&
              uploadedImages.map((item, index) => (
                <div className='outerImageBox' key={index}>
                  {item.valid ? (
                    <React.Fragment>
                      <div
                        className='imageBox'
                        key={index}
                        onClick={this.addPhoto.bind(this, index, 'uploaded')}
                      >
                        <img
                          src={item.url}
                          alt=''
                          onLoad={this.checkIfImageUploded.bind(this, index)}
                        />
                        {item.isUpload ? (
                          <span className='isUpload'>
                            <CheckCircleFill size={20} color={green.z500} />
                          </span>
                        ) : null}
                      </div>
                      {item.isUpload ? (
                        <span
                          className='cancelUploadImg pointer'
                          onClick={this.cancelUploadedImg.bind(this, item)}
                        >
                          <CrossCircleFill size={20} color={black.z500} />
                        </span>
                      ) : null}
                    </React.Fragment>
                  ) : null}
                </div>
              ))}
            {isLoading ? (
              <div className='imageBox outerImageBox'>
                <SpinnerCircular size='small' />
              </div>
            ) : null}
            <form method='post' encType='multipart/form-data'>
              <input
                type='file'
                name='files[]'
                id='uploadInput'
                onChange={this.onChange}
                multiple
              />
              <label className='uploadBtnBox' htmlFor='uploadInput'>
                <span className='uploadBtn'>
                  <Plus size={20} color={green.z500} />
                </span>
              </label>
            </form>
          </div>
        </div>
        {(availablePhotos && availablePhotos.length) ||
        (riderPhotos && riderPhotos.length) ||
        (samplePhotos && samplePhotos.length) ? (
          <div className='selectAvailablePhotosWrapper col mt10'>
            <div className='row'>
              <Heading title='or Select from available photos' />
            </div>
            <div className='uploadedImages'>
              {!!(availablePhotos && availablePhotos.length) &&
                availablePhotos &&
                availablePhotos.map((item, index) => (
                  <div className='imageBox outerImageBox mb10' key={index}>
                    <img
                      key={index}
                      className='pointer'
                      src={item.url}
                      alt=''
                      onClick={this.uploadAvailablePhotos.bind(this, item)}
                    />
                  </div>
                ))}
              {!!(riderPhotos && riderPhotos.length) &&
                riderPhotos.map((item, index) => (
                  <div
                    className='imageBox outerImageBox mb10'
                    key={index}
                    onClick={this.addPhoto.bind(this, index, 'rider')}
                  >
                    <img
                      key={index}
                      className='pointer'
                      src={item.url}
                      alt=''
                    />
                    <span className='riderImage pointer'>
                      <Label title='Rider' bgColor='#256FEF' showIcon={false} />
                    </span>
                  </div>
                ))}
              {!!(samplePhotos && samplePhotos.length) &&
                samplePhotos.map((item, index) => (
                  <div
                    className='imageBox outerImageBox mb10'
                    key={index}
                    onClick={this.addPhoto.bind(this, index, 'sample')}
                  >
                    <img
                      key={index}
                      className='pointer'
                      src={item.url}
                      alt=''
                    />
                    <span className='riderImage pointer'>
                      <Label
                        title='Sample'
                        bgColor='#256FEF'
                        showIcon={false}
                      />
                    </span>
                  </div>
                ))}
            </div>
          </div>
        ) : null}
        {uploadedImages && uploadedImages.length ? (
          <div id='photoViewer'>
            <PhotoViewer
              isOpen={isOpen}
              handleClose={this.closePhotoViewer}
              data={uploadedImages}
              currentIndex={selectedImageInd}
              FooterNumbers={0}
              showUploader={false}
            />
          </div>
        ) : null}
        {riderPhotos && riderPhotos.length ? (
          <div id='photoViewer'>
            <PhotoViewer
              isOpen={isRiderOpen}
              handleClose={this.closePhotoViewer}
              data={riderPhotos}
              currentIndex={selectRiderImageIdx}
              FooterNumbers={0}
              showUploader={false}
            />
          </div>
        ) : null}
        {samplePhotos && samplePhotos.length ? (
          <div id='photoViewer'>
            <PhotoViewer
              isOpen={isSampleOpen}
              handleClose={this.closePhotoViewer}
              data={samplePhotos}
              currentIndex={selectSampleImageIdx}
              FooterNumbers={0}
              showUploader={false}
            />
          </div>
        ) : null}
        {showToast ? (
          <Toast
            show={showToast}
            align='top'
            text={toastText}
            type={toastType}
            onClose={this.closeToast}
          />
        ) : null}
      </div>
    );
  }
}
